<p-sidebar [(visible)]="display" [fullScreen]="true" styleClass="about-client-app-dialog" [baseZIndex]="10000" appendTo="body">

  <div class="about-title-bar">
    <ng-template #mojoDashboardTitle>
      <h1>About <img src="/assets/brand/brands/mojo/iconlogos.png" width="120" /> with added <img src="/assets/brand/brands/mojo/logo-outlined-white.png" width="71" height="34" /></h1>
    </ng-template>
    <ng-template #mojoPlatformTitle>
      <h1>About {{appName | async}}</h1>
    </ng-template>
    <ng-container *ngIf="isMojoDashboard | async; then mojoDashboardTitle else mojoPlatformTitle"></ng-container>
  </div>
  <div class="row">
    <div class="col-sm-6" >{{appName | async}} Version</div>
    <div class="col-sm-6">{{(displayVersion | async)}}</div>
  </div>
  <div class="row" *ngFor="let item of (aboutDetails | async)?.items">
    <div class="col-sm-6">{{item.title}}</div>
    <div class="col-sm-6" *ngIf="item.url == null">{{item.value}}</div>
    <div class="col-sm-6 external-link" *ngIf="item.url != null"><a [attr.href]="item.url">{{item.value}}</a></div>
  </div>
  <div class="row">
    <div class="col-sm-12 about-copyright-information"><a [attr.href]="(aboutDetails | async)?.traceUrl">{{(aboutDetails | async)?.copyrightInformation}}</a></div>
  </div>
  <button class="overlay-about-close-button" pButton type="button" (click)="closeAboutDialog()" label="Close"></button>
</p-sidebar>
